import React, { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import {
    PaymentConditionDataForm,
    defaultPaymentConditionDataForm
} from '../../../app/models/PaymentCondition';
import usePaymentConditionService from '../../../app/services/hooks/usePaymentConditionService';
import PaymentConditionForm from './forms/PaymentConditionForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const PaymentConditionCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [paymentCondition, setPaymentCondition] = useState<PaymentConditionDataForm>(
        defaultPaymentConditionDataForm
    );
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStorePaymentCondition, storePaymentCondition } = usePaymentConditionService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando condición de pago...');
        storePaymentCondition(paymentCondition, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <PaymentConditionForm
                        paymentConditionDataForm={paymentCondition}
                        setPaymentConditionDataForm={setPaymentCondition}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStorePaymentCondition} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm
                        callbackSave={store}
                        locked={fetchingStorePaymentCondition}
                    />
                </div>
            </div>
        </>
    );
};

export default PaymentConditionCreate;
